"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.derivePrice = exports.formatPriceString = exports.deriveCurrencySymbol = exports.sortByDistanceFromMapFocus = exports.derivePower = exports.derivePowerValues = exports.deriveTime = exports.haversineDistance = exports.connectorData = exports.chargeSpeedData = exports.roundDistance = void 0;
exports.roundDistance = (m) => {
    if (m || m === 0) {
        if (m >= 5000)
            return `${Math.round(m / 1000)}km`;
        if (m >= 500)
            return `${Math.round(m / 100) / 10}km`;
        return `${Math.round(m)}m`;
    }
    return '';
};
exports.chargeSpeedData = [
    {
        title: 'pulse150',
        subtitle: '150kW +',
        icon: 'Ultrafast',
        activeColor: '#090',
        inactiveColor: '#090',
        value: 150,
        minValue: 100,
    },
    {
        title: 'pulse50',
        subtitle: '50kW',
        icon: 'Rapid',
        activeColor: '#BE06FF',
        inactiveColor: '#BE06FF',
        value: 99,
        minValue: 43,
    },
    {
        title: 'pulse7',
        subtitle: '7 - 22kW',
        icon: 'Fast',
        activeColor: '#00AEEF',
        inactiveColor: '#00AEEF',
        value: 42,
        minValue: 7,
    },
    {
        title: 'pulse3',
        subtitle: '3kW',
        icon: 'Standard',
        activeColor: '#FFBC3D',
        inactiveColor: '#FFBC3D',
        value: 6,
        minValue: 0,
    },
];
exports.connectorData = [
    {
        title: 'CHAdeMO',
        icon: 'ConnectorCHAdeMO',
        activeColor: '#000096',
        inactiveColor: '#666',
    },
    {
        title: 'Type 2',
        icon: 'ConnectorType2',
        activeColor: '#000096',
        inactiveColor: '#666',
    },
    {
        title: 'CCS',
        icon: 'ConnectorCCS',
        activeColor: '#000096',
        inactiveColor: '#666',
    },
];
exports.haversineDistance = (
// Takes a set of coordinates (degrees) and returns distance between them (metres)
a, b) => {
    // radius of earth in m
    const r = 6371000;
    // Convert to radians
    const aRad = { lat: (a.lat * Math.PI) / 180, lon: (a.lon * Math.PI) / 180 };
    const bRad = { lat: (b.lat * Math.PI) / 180, lon: (b.lon * Math.PI) / 180 };
    // Haversine
    const u = Math.sin((bRad.lat - aRad.lat) / 2) ** 2;
    const v = Math.cos(aRad.lat) *
        Math.cos(bRad.lat) *
        Math.sin((bRad.lon - aRad.lon) / 2) ** 2;
    // Calculate arc
    return r * 2 * Math.asin(Math.sqrt(u + v));
};
exports.deriveTime = (hours) => {
    const day = new Date().getDay();
    const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    const index1 = `${days[day]}1`;
    const index2 = `${days[day]}2`;
    if (Object.prototype.hasOwnProperty.call(hours, index1) &&
        hours.hasOwnProperty.call(hours, index2)) {
        // cannot use string as keys of original hours because they do not exist on type {}
        // at this point it is safe to set type to any because we have checked the properties exist
        const tempHours = hours;
        return `${tempHours[index1]} - ${tempHours[index2]}`;
    }
    return '24/7';
};
exports.derivePowerValues = (connectors) => {
    const ratings = connectors.map(({ rating }) => rating);
    const minPower = Math.min(...ratings);
    const maxPower = Math.max(...ratings);
    return {
        minPower,
        maxPower,
    };
};
exports.derivePower = (connectors) => {
    const { minPower, maxPower } = exports.derivePowerValues(connectors);
    return minPower === maxPower
        ? `${maxPower}kW`
        : `${minPower} - ${maxPower}kW`;
};
exports.sortByDistanceFromMapFocus = (chargepoints) => {
    return chargepoints.sort((a, b) => {
        if (!a.distanceFromMapFocus || !b.distanceFromMapFocus)
            return 0;
        if (a.distanceFromMapFocus < b.distanceFromMapFocus)
            return -1;
        if (a.distanceFromMapFocus > b.distanceFromMapFocus)
            return 1;
        return 0;
    });
};
exports.deriveCurrencySymbol = (currencyString) => {
    const currencies = {
        GBP: '\u00A3',
        EUR: '\u20AC',
    };
    return currencies[currencyString] || '\u00A3';
};
exports.formatPriceString = ({ price, currency }) => {
    if (currency === '\u20AC') {
        return `${price.replace('.', ',')} ${currency}/kWh`;
    }
    return `${currency}${price}/kWh`;
};
exports.derivePrice = ({ userType, costOfCharge, free = false, }) => {
    let price = '';
    let strikedPrice = '';
    const userTypeData = !userType || userType === 'Guest' || userType === 'New'
        ? 'Guest'
        : userType;
    costOfCharge.forEach((userTypeCost) => {
        const type = userTypeCost && userTypeCost.tariff && userTypeCost.tariff.type;
        const cost = userTypeCost && userTypeCost.tariff && userTypeCost.tariff.cost;
        const formattedCost = cost && Number(cost).toFixed(2);
        const unit = userTypeCost && userTypeCost.tariff && userTypeCost.tariff.unit;
        if (userTypeData === type) {
            const currency = exports.deriveCurrencySymbol(unit);
            if (free === true) {
                strikedPrice = '';
                price = exports.formatPriceString({ price: '0.00', currency });
            }
            else {
                strikedPrice = '';
                price = exports.formatPriceString({ price: formattedCost, currency });
            }
        }
    });
    return {
        price,
        strikedPrice,
    };
};
